/**
 * Builds WhatsApp inquiry links with product, variant, carat, and shape details.
 */
(function () {
  const INQUIRY_SELECTOR = '[data-inquiry-button]';

  function getWhatsAppBase(link) {
    if (!link || link === '#') return 'https://wa.me/971569940388';
    try {
      const url = new URL(link, window.location.origin);
      return `${url.origin}${url.pathname}`;
    } catch {
      return link.split('?')[0];
    }
  }

  function normalizeOptionName(name) {
    return (name || '').toLowerCase().trim();
  }

  function getSelectedOptionValue(optionName) {
    const target = normalizeOptionName(optionName);
    const fieldsets = document.querySelectorAll('variant-selects fieldset, .product-form__input--pill');

    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector('legend, .form__label');
      const label = normalizeOptionName(legend?.textContent?.replace(':', '').split('\n')[0]);
      if (!label.includes(target)) continue;

      const checked = fieldset.querySelector('input:checked, select');
      if (checked?.value) return checked.value.trim();
    }

    return '';
  }

  function getCaratValue() {
    const urlCarat = new URLSearchParams(window.location.search).get('carat');
    if (urlCarat) return urlCarat.trim();

    const metafieldCarat = document.getElementById('metafield-display-carat')?.textContent?.trim();
    if (metafieldCarat) return metafieldCarat;

    const fieldsets = document.querySelectorAll('variant-selects fieldset, .product-form__input--pill');
    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector('legend, .form__label');
      const label = normalizeOptionName(legend?.textContent?.replace(':', '').split('\n')[0]);
      if (!label.includes('carat') || label.includes('carat look')) continue;
      const checked = fieldset.querySelector('input:checked, select');
      if (checked?.value) return checked.value.trim();
    }

    return getSelectedOptionValue('carat');
  }

  function getShapeValue() {
    const urlShape = new URLSearchParams(window.location.search).get('shape');
    if (urlShape) return urlShape.trim();

    const shapeOption = getSelectedOptionValue('shape');
    if (shapeOption) return shapeOption;

    const fieldsets = document.querySelectorAll('variant-selects fieldset, .product-form__input--pill');
    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector('legend, .form__label');
      const label = normalizeOptionName(legend?.textContent?.replace(':', '').split('\n')[0]);
      if (label !== 'shape' && !label.endsWith(' shape')) continue;
      const checked = fieldset.querySelector('input:checked, select');
      if (checked?.value) return checked.value.trim();
    }

    return '';
  }

  function getSelectedVariant() {
    const variantJson = document.querySelector('variant-selects [data-selected-variant]')?.textContent;
    if (variantJson) {
      try {
        return JSON.parse(variantJson);
      } catch {
        return null;
      }
    }
    return null;
  }

  function getVariantId(button) {
    const variant = getSelectedVariant();
    if (variant?.id) return String(variant.id);

    const formId = button.closest('form')?.id;
    const variantInput = formId
      ? document.querySelector(`#${formId} input[name="id"]`)
      : document.querySelector('input[name="id"].product-variant-id, input[name="id"]');

    return variantInput?.value || button.dataset.variantId || '';
  }

  function getVariantTitle(button) {
    const variant = getSelectedVariant();
    if (variant?.title) return variant.title;
    return button.dataset.variantTitle || '';
  }

  function buildProductUrl(button, variantId, carat, shape) {
    const basePath = button.dataset.productUrl || '';
    const origin = window.shopUrl || window.location.origin;
    const url = new URL(basePath, origin);

    if (variantId) url.searchParams.set('variant', variantId);
    if (carat) url.searchParams.set('carat', carat);
    if (shape) url.searchParams.set('shape', shape);

    return url.toString();
  }

  function buildInquiryMessage(button) {
    const title = button.dataset.productTitle || '';
    const variantId = getVariantId(button);
    const variantTitle = getVariantTitle(button);
    const carat = getCaratValue();
    const shape = getShapeValue();
    const productUrl = buildProductUrl(button, variantId, carat, shape);

    const lines = [`Hello, I want to order this product: ${title}`, `Product URL: ${productUrl}`];

    if (variantTitle) lines.push(`Variant: ${variantTitle}`);
    if (carat) lines.push(`Carat: ${carat}`);
    if (shape) lines.push(`Shape: ${shape}`);

    return lines.join('\n');
  }

  function buildInquiryHref(button) {
    const base = getWhatsAppBase(button.dataset.whatsappBase || window.inquiryButtonLink);
    const message = buildInquiryMessage(button);
    return `${base}?text=${encodeURIComponent(message)}`;
  }

  function updateInquiryButton(button) {
    if (!button) return;
    button.href = buildInquiryHref(button);
  }

  function updateAllInquiryButtons() {
    document.querySelectorAll(INQUIRY_SELECTOR).forEach(updateInquiryButton);
  }

  function bindInquiryButtonEvents() {
    document.querySelectorAll('.Hw__product-input, input[name^="options"], select[name^="options"]').forEach((input) => {
      input.addEventListener('change', updateAllInquiryButtons);
    });

    document.querySelectorAll('input[name="id"]').forEach((input) => {
      input.addEventListener('change', updateAllInquiryButtons);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, updateAllInquiryButtons);
    }
  }

  function initInquiryButtons() {
    updateAllInquiryButtons();
    bindInquiryButtonEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInquiryButtons);
  } else {
    initInquiryButtons();
  }

  document.addEventListener('product-info:loaded', initInquiryButtons);
})();
